export default __webpack_public_path__ + "static/media/roboto-v20-cyrillic_latin-500.ec55685e.woff";